const axios             = require('axios');
import ScrollEvents from './ScrollEvents'

const AjaxLoadPage = function()
{
    // const $elLoad       = $("#loaderPage");
    // const _body         = $("body");
    // const _menu         = $("#nav-header");
    const _header       = $("#header");
    // const _introLayer   = $("#layerIntroPage");
    // const _timerSync    = 10;


    const pageLoader = function() {

            //_body.removeClass('no-scroll body-content-loading');
            //_introLayer.addClass('motion-out');
            _header.addClass('motion-in');
            setTimeout(()=>{
                ScrollEvents.animeTextIntro(".text-anim");
            },700)

    }


    return {
        init : function(status){

            pageLoader();


        }
    }

}();

export default AjaxLoadPage;
